import { CardUnified } from './CardUnified';

/**
 * CardPostMetric 컴포넌트 (하위 호환 래퍼)
 *
 * CardUnified 의 variant="postMetric" 로 위임한다. 신규 코드는 CardUnified 를 직접 사용 권장.
 * 파일명(CardPostMeric)은 기존 import 경로 호환을 위해 유지한다.
 *
 * @param {Object} thread - 스레드 데이터 [Required]
 * @param {string} date - 표시할 날짜 [Optional]
 * @param {number} rd - 모서리 둥글기(px) [Optional, 기본값: 8]
 * @param {('full'|'bottom'|'left'|'right'|'top')} borderType - 테두리 형태 [Optional, 기본값: 'full']
 * @param {string} size - (레거시 prop, 미사용) [Optional, 기본값: 'lg']
 * @param {boolean} isRemarkable - 어워드 아이콘 강제 노출 [Optional, 기본값: false]
 * @param {boolean} isRanked - 랭크 배지 노출 [Optional, 기본값: false]
 * @param {number} rank - 랭크 숫자 [Optional, 기본값: 0]
 *
 * Example usage:
 * <CardPostMetric thread={thread} date={thread.timestamp} isRanked rank={1} />
 */
export const CardPostMetric = ({
  thread,
  date,
  rd = 8,
  borderType = 'full',
  isRemarkable = false,
  isRanked = false,
  rank = 0,
}) => (
  <CardUnified
    variant="postMetric"
    thread={thread}
    date={date}
    rd={rd}
    borderType={borderType}
    isRemarkable={isRemarkable}
    isRanked={isRanked}
    rank={rank}
  />
);
